export const appVersion = "v1.8.0"
export const appVersionComplete = "v1.1.0 T-Rex"

export const apiImagePath = 'https://image.tmdb.org/t/p'

export const rootUrl = 'https://www.moviebookapp.eu'

export const idValerio = 'z9tB7Z0ClphX0grBpUSk'
export const idPhantom = 'rPzgY4t76Bw2pQ7Xo5SJ'
